import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { SKILLS } from "./About";
import { PROJECTS } from "./Projects";
import { ProjectCard, ProjectModal } from "../components/Netflix";

const CATS = ["All", "Web Application", "Mobile App", "Data Science"];

export default function Browse() {
  const [cat, setCat] = useState("All");
  const [proj, setProj] = useState(null);
  const [sp] = useSearchParams();
  const raw = (sp.get("q") || "").trim();
  const q = raw.toLowerCase();
  const has = s => String(s).toLowerCase().includes(q);

  useEffect(() => { document.title = "Projects | Aayam Bhattarai"; }, []);

  const list = PROJECTS.filter(p =>
    (cat === "All" || p.category === cat) &&
    (!q || [p.title, p.desc, p.category, p.status, ...p.stack].some(has))
  );
  const skills = q ? SKILLS.filter(s => has(s.name) || has(s.tag)) : [];

  return (
    <main className="nx-page">
      <div className="nx-ph">
        <p className="nx-ph-eye"><span>P</span> Portfolio</p>
        <h1>{raw ? <>Results for “{raw}”</> : "Projects"}</h1>
        <p className="nx-ph-sub">
          {raw
            ? `${list.length} matching project${list.length === 1 ? "" : "s"}`
            : "Selected work across web, mobile and data science. Hover a card for a quick look, or open it for the full story."}
        </p>
        <div className="nx-pills">
          {CATS.map(c => (
            <button key={c} className={`nx-chip${cat === c ? " on" : ""}`} onClick={() => setCat(c)}>
              {c}
              <small>{c === "All" ? PROJECTS.length : PROJECTS.filter(p => p.category === c).length}</small>
            </button>
          ))}
        </div>
      </div>

      {skills.length > 0 && (
        <div className="nx-sk-res">
          <h2>Skills</h2>
          <div className="nx-wrap">
            {skills.map(s => {
              const Icon = s.icon;
              return (
                <div className="nx-skill" key={s.name} style={{ "--c": s.color, "--pct": `${s.pct}%` }}>
                  <Icon />
                  <div><b>{s.name}</b><span><em>{s.pct}% match</em> · {s.tag}</span><i className="nx-bar" /></div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {list.length > 0 ? (
        <div className="nx-grid">
          {list.map(p => <ProjectCard key={p.id} p={p} onOpen={setProj} />)}
        </div>
      ) : (
        <div className="nx-empty">
          <p>Your search for “{raw || cat}” did not have any matches.</p>
          <p>Try keywords like React, Python, Android or MongoDB.</p>
        </div>
      )}

      {proj && <ProjectModal p={proj} all={PROJECTS} onClose={() => setProj(null)} onSelect={setProj} />}
    </main>
  );
}
